import React, { useEffect, useState } from 'react';
import PurchaseGlasses from '../../components/purchaseGlasses';
import CardRegisterWrapper from './cardRegisterWrapper';
import ScrollToTopOnMount from '../../components/global/scrollToTopOnMount';
import BlockRegistration from '../../components/redirectExternal/blockRegistration';
import { CommerceService } from '../../services/commerceService';
import * as Edge from '../../core';
import { CheckoutProps } from '../checkout/models';

export interface Page2Props extends CheckoutProps {
	prices: Edge.Models.Price[];
}

function Page2(props: Page2Props) {
	const [url, setUrl] = useState<string>();

	useEffect(() => {
		if (url) {
			window.location.href = url;
		}
	}, [url]);

	const { model, onChange } = props;
	if (!model.price) {
		return <BlockRegistration />;
	}

	return (
		<CardRegisterWrapper {...props} allowEdit={model.price.price.priceType !== Edge.Models.PriceTypes.Recurring}>
			<ScrollToTopOnMount />
			<PurchaseGlasses
				showRecurringSubscriptionFields={false}
				onSubmit={async (values) => {
					const checkout = await CommerceService.createCheckoutSession({
						cancelUrl: 'https://vizualedge.com/signup/',
						checkoutSessionType: Edge.Models.CheckoutSessionType.Initial,
						country: values.country,
						email: model.email || 'None',
						entityId: model.organizationId!,
						entityType: Edge.Models.EntityType.Organization,
						glassesQuantity: parseInt(values.glassesNumber, 10),
						mode:
							model.price!.price.priceType === Edge.Models.PriceTypes.Recurring
								? 'subscription'
								: 'payment',
						name: model.userFullName || 'N/A',
						organizationId: model.organizationId!,
						price: model.price!.price.id,
						quantity: model.quantity!,
						sport: model.sport || 'None',
						successUrl: `${origin}/checkout-successful`,
					});

					await onChange({ numberOfGlasses: parseInt(values.glassesNumber, 10) });
					setUrl(checkout.url);
				}}
			/>
		</CardRegisterWrapper>
	);
}

export default Page2;
